var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultBaseProps, defaultBaseLineProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { validProgress, handleGradient } from './common';
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line(props) {
        return _super.call(this, props) || this;
    }
    Line.prototype.render = function () {
        var _a = this.props, percent = _a.percent, strokeColor = _a.strokeColor, trailColor = _a.trailColor, strokeWidth = _a.strokeWidth, children = _a.children, strokeLinecap = _a.strokeLinecap, showInfo = _a.showInfo, className = _a.className, rest = __rest(_a, ["percent", "strokeColor", "trailColor", "strokeWidth", "children", "strokeLinecap", "showInfo", "className"]);
        var backgroundProps = strokeColor && typeof strokeColor !== 'string'
            ? handleGradient(strokeColor)
            : {
                background: strokeColor,
            };
        var atomicsOuter = ['inline-flex', 'w-full', 'items-center'];
        var atomicsInner = [
            'w-full',
            'overflow-hidden',
            'inline-block',
            'rounded-lg',
        ];
        var atomicsBg = [
            'rounded-lg',
            'transition-all',
            'duration-slow',
            'ease-out-circ',
        ];
        var bgStyle = __assign({ width: validProgress(percent) + "%", height: strokeWidth || 8, borderRadius: strokeLinecap === 'square' ? 0 : '' }, backgroundProps);
        var trailStyle = trailColor
            ? {
                backgroundColor: trailColor,
            }
            : undefined;
        return (React.createElement(React.Fragment, null,
            React.createElement(DivTag, __assign({ atomics: atomicsOuter }, rest, { className: showInfo ? "legao-line-outer " + className : className }),
                React.createElement(DivTag, { atomics: atomicsInner, style: trailStyle },
                    React.createElement(DivTag, { atomics: atomicsBg, style: bgStyle }))),
            children));
    };
    Line.defaultProps = Object.assign(defaultBaseProps, defaultBaseLineProps);
    return Line;
}(PureComponent));
export default Line;
